/**
 * Presentational renderer for the cancellation + change policy text from
 * /trips/calculate-policies (flat shape: cancellation.text / modification.text).
 *
 * Section headings are static; the sentences come from the API. Never fabricates
 * copy — if both texts are absent (admin mistake, or policies not loaded) it
 * shows a contact-us empty state instead of fake content.
 *
 * Props:
 *  - cancellationText / modificationText: the policy sentences (may be undefined)
 *  - error: 'empty' (no content) | any other truthy (connection/error) | null
 */
export default function PolicyPopupContent({cancellationText, modificationText, error = null}) {
    if (error || (!cancellationText && !modificationText)) {
        return (
            <div className="hopn-instruction-layout">
                <h5>{error && error !== 'empty' ? 'Connection issue!' : 'Please contact us for details!'}</h5>
            </div>
        )
    }

    return (
        <div className="hopn-instruction-layout">
            <h3>Cancellation Policy</h3>
            <span className="spacial-layout">{cancellationText}</span>
            <h3>Change Policy</h3>
            <span className="spacial-layout">{modificationText}</span>
        </div>
    )
}
